import React, { useContext, useEffect, useState } from "react";
import { Content } from "antd/es/layout/layout";
import { Card, Col, Row, Tag, Badge, Divider, Spin, Tooltip } from "antd";
import { StarFilled } from "@ant-design/icons";
import { GetJavamonConfig, getJavamonImage, GetSkins, GetUserEquipment } from '../../../dao/jutge/GetJavamonConfig';
import { AuthContext } from "../../../config/AuthContext";
import Login from "../../Login";
import { GetJutgeUsuariIdJavamons } from "../../../dao/jutge/GetJutgeUsuariIdJavamons";
import { GetJutgeUsuariIdPoints } from "../../../dao/jutge/GetJutgeUsuariIdPoints";
import { RenameJavamon } from "../../../dao/jutge/RenameJavamon";
import { UseItem } from "../../../dao/jutge/UseItem";
import { ApplyJavamonAbility } from "../../../dao/jutge/ApplyJavamonAbility";
import { EvolveUserEquipment, EvolveUserJavamon } from "../../../dao/jutge/EvolveItem";
import { Modal, Input, Button, Select, message } from "antd";
import { TbPokeball } from "react-icons/tb";
import { useLocation } from "react-router-dom";
import { EditOutlined, RetweetOutlined, CheckCircleOutlined, CloseCircleOutlined, ArrowRightOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { GetUserTrades, SendTradeRequest, ProposeTrade, AcceptTrade, RejectTrade, GetAllUsers } from "../../../dao/jutge/TradeActions";
import { PostGenerateRandomAvatar, GeneratedAvatarResult } from "../../../dao/jutge/PostGenerateRandomAvatar";
import { Alert } from "antd";

const apiUrl = process.env.REACT_APP_API_URL;

interface Javamon {
    id: number;
    id_instance: number;
    nom: string;
    descr: string | null;
    image: string;
    rarity: string;
    captura: string;
    used?: number;
    vida?: number;
    defensa?: number;
    velocidad?: number;
    ataque?: number;
}

interface Objecte {
    id: number;
    tipo: string;
    color: string;
    punts: number;
    descripcio: string;
    image?: string;
    imagen?: string;
    imatge?: string;
    Imagen?: string;
    ability?: string;
    has_image?: number;
    id_item?: number;
}

const fallbackRarityStyle: Record<
    string,
    { color: string; tag: string }
> = {
    normal: {
        color: "#555",
        tag: "blue",
    },
    epic: {
        color: "#f1c40f", // amarillo
        tag: "gold",
    },
    legendary: {
        color: "#9b59b6", // lila
        tag: "purple",
    },
};
interface MochilaProps {
    user_id_simulado?: string;
}

const Mochila: React.FC<MochilaProps> = ({ user_id_simulado }) => {
    const { isLoggedIn, userId, setBreadCrumb } = useContext(AuthContext);
    const location = useLocation();
    const user_id_simulado_from_state = location.state?.user_id_simulado;
    const [loading, setLoading] = useState(true);
    const [javamons, setJavamons] = useState<Javamon[]>([]);
    const [objects, setObjects] = useState<Objecte[]>([]);
    const [rarityMap, setRarityMap] = useState<Record<string, string>>({});

    const [modalVisible, setModalVisible] = useState(false);
    const [modalType, setModalType] = useState<'rename' | 'incense' | 'ability' | 'trade' | 'propose' | 'evolve' | 'generate_avatar' | 'none'>('none');

    // "Generar Avatar": resultat (skin + avatar) generat aleatòriament
    const [generatedResult, setGeneratedResult] = useState<GeneratedAvatarResult | null>(null);
    const [resultModalVisible, setResultModalVisible] = useState(false);
    const [selectedObject, setSelectedObject] = useState<Objecte | null>(null);
    const [selectedJavamonIdx, setSelectedJavamonIdx] = useState<number | undefined>(undefined);
    const [newName, setNewName] = useState('');
    const [actionLoading, setActionLoading] = useState(false);
    const [users, setUsers] = useState<{ id: number, nom: string }[]>([]);
    const [selectedReceiverId, setSelectedReceiverId] = useState<number | undefined>(undefined);
    const [pendingTrades, setPendingTrades] = useState<any[]>([]);
    const [selectedTrade, setSelectedTrade] = useState<any>(null);

    // Equipamiento y evoluciones
    const [allSkins, setAllSkins] = useState<any>({ skins: [], armes: [], escuts: [], arcs: [] });
    const [userEquipment, setUserEquipment] = useState<any>(null);
    const [allJavamonsConfig, setAllJavamonsConfig] = useState<any[]>([]);
    const [evolveType, setEvolveType] = useState<'arma' | 'escut' | 'arc' | 'javamon' | null>(null);
    const [selectedEvolveItem, setSelectedEvolveItem] = useState<any>(null);
    const [confirmModalVisible, setConfirmModalVisible] = useState(false);

    const idUsuario = user_id_simulado || user_id_simulado_from_state || userId;

    useEffect(() => {
        if (isLoggedIn) loadData();
        setBreadCrumb(
            [
                { nom: "Home", nav: "/home" },
                { nom: "Inventari", nav: "/mochila" },
            ],
            true
        );
    }, [isLoggedIn, idUsuario]); // dependemos de idUsuario

    const loadData = async () => {
        setLoading(true);
        try {
            const jm = await GetJutgeUsuariIdJavamons(idUsuario + "");
            const objs = await GetJutgeUsuariIdPoints(idUsuario + "");

            try {
                const data = await GetJavamonConfig();
                if (data) {
                    const rList = data.rarities && data.rarities !== "null" ? JSON.parse(data.rarities) : [];
                    const rMap: Record<string, string> = {};
                    rList.forEach((r: any) => {
                        const n = r.nom?.toLowerCase() || '';
                        rMap[n] = r.color;
                        rMap[r.nom] = r.color;
                        if (n === 'épico' || n === 'epico') rMap['epic'] = r.color;
                        if (n === 'legendario' || n === 'leyenda') rMap['legendary'] = r.color;
                        if (n === 'normal' || n === 'comun' || n === 'común') rMap['normal'] = r.color;
                    });
                    setRarityMap(rMap);
                    if (data.javamons) {
                        setAllJavamonsConfig(data.javamons);
                    }
                }
            } catch (err) {
                console.error("Error cargando colores de rareza:", err);
            }

            try {
                const skinsData = await GetSkins();
                if (skinsData) {
                    setAllSkins({
                        skins: skinsData.skins || [],
                        armes: skinsData.armes || [],
                        escuts: skinsData.escuts || [],
                        arcs: skinsData.arcs || []
                    });
                }
                const eq = await GetUserEquipment(idUsuario);
                if (eq) {
                    setUserEquipment(eq);
                }
            } catch (err) {
                console.error("Error cargando equipamiento:", err);
            }

            setJavamons(jm ?? []);
            setObjects(objs ?? []);

            const trades = await GetUserTrades(idUsuario + "");
            setPendingTrades(trades);

            const allUsers = await GetAllUsers(idUsuario + "");
            setUsers(allUsers.filter((u: any) => u.id !== Number(idUsuario)));
        } catch (e) {
            console.error("Error cargando mochila:", e);
        } finally {
            setLoading(false);
        }
    };

    // ITEM HANDLERS
    const handleItemClick = (obj: Objecte) => {
        setSelectedObject(obj);
        const tipoLower = obj.tipo?.toLowerCase() || '';

        if (tipoLower.includes("mejora de arma") || tipoLower.includes("mejora d'arma")) {
            setEvolveType('arma');
            setSelectedEvolveItem(null);
            setModalType('evolve');
            setModalVisible(true);
        } else if (tipoLower.includes("mejora de escudo") || tipoLower.includes("mejora d'escut") || tipoLower.includes("mejora de escut")) {
            setEvolveType('escut');
            setSelectedEvolveItem(null);
            setModalType('evolve');
            setModalVisible(true);
        } else if (tipoLower.includes("mejora de arco") || tipoLower.includes("mejora d'arc") || tipoLower.includes("mejora de arc")) {
            setEvolveType('arc');
            setSelectedEvolveItem(null);
            setModalType('evolve');
            setModalVisible(true);
        } else if (tipoLower.includes("mejora de javamon") || tipoLower.includes("mejora javamon")) {
            setEvolveType('javamon');
            setSelectedEvolveItem(null);
            setModalType('evolve');
            setModalVisible(true);
        } else if (
            tipoLower.includes("generar avatar") ||
            tipoLower.includes("genera avatar") ||
            (obj.ability && obj.ability.toUpperCase() === 'GENERAR_AVATAR') ||
            obj.id_item === 7
        ) {
            setModalType('generate_avatar');
            setModalVisible(true);
        } else if (tipoLower.includes("pergamino de nombre") || tipoLower.includes("name scroll") || tipoLower.includes("pergamino renombre")) {
            setModalType('rename');
            setSelectedJavamonIdx(undefined); // Reset correctly
            setNewName('');
            setModalVisible(true);
        } else if (tipoLower.includes("incienso") || tipoLower.includes("incense")) {
            setModalType('incense');
            setModalVisible(true);
        } else if (obj.ability || tipoLower.includes("ability") || tipoLower.includes("épico") || tipoLower.includes("epico") || tipoLower.includes("legendario")) {
            setModalType('ability');
            setSelectedJavamonIdx(undefined);
            setModalVisible(true);
        }
    };

    const confirmAction = async () => {
        if (!selectedObject && modalType !== 'propose' && modalType !== 'trade') return;
        setActionLoading(true);

        try {
            if (modalType === 'rename') {
                if (selectedJavamonIdx === undefined || !newName.trim()) {
                    console.error("Missing input");
                    setActionLoading(false);
                    return;
                }
                const javamon = javamons[selectedJavamonIdx];
                const instanceId = javamon.id_instance;
                const success = await RenameJavamon(instanceId, newName);
                if (success && selectedObject) {
                    await UseItem(selectedObject.id); // Consume item
                    loadData(); // Refresh to see name change and item removed
                    setModalVisible(false);
                } else {
                    message.error("No se ha podido renombrar: Falta el id_instance.");
                }
            } else if (modalType === 'incense') {
                // 30 mins from now
                const expiry = Date.now() + 30 * 60 * 1000;
                localStorage.setItem('incense_expiry', expiry.toString());
                window.dispatchEvent(new Event('storage')); // Notify other tabs/components

                if (!selectedObject) return;
                const success = await UseItem(selectedObject.id);
                if (success) {
                    loadData();
                    setModalVisible(false);
                }
            } else if (modalType === 'generate_avatar') {
                if (!selectedObject) return;
                const result = await PostGenerateRandomAvatar(idUsuario + "", selectedObject.id);
                if (result && (result.skinId !== null || result.avatarId !== null)) {
                    setGeneratedResult(result);
                    setModalVisible(false);
                    setResultModalVisible(true);
                    await loadData();
                } else {
                    message.warning("No hay skins ni avatares disponibles para generar en este momento. Necesitas recompensas de actividades finalizadas que aún no tengas.");
                }
            } else if (modalType === 'ability') {
                if (selectedJavamonIdx === undefined) {
                    message.error("Debes seleccionar un Javamon primero.");
                    setActionLoading(false);
                    return;
                }
                const javamon = javamons[selectedJavamonIdx];
                const instanceId = javamon.id_instance;
                if (!instanceId) {
                    message.error("El Javamon no tiene id_instance válido.");
                    setActionLoading(false);
                    return;
                }

                if (!selectedObject) return;
                const success = await ApplyJavamonAbility(selectedObject.id, instanceId);
                if (success) {
                    message.success("¡Habilidad aplicada con éxito!");
                    loadData();
                    setModalVisible(false);
                } else {
                    message.error("Ha ocurrido un error al aplicar la habilidad.");
                }
            } else if (modalType === 'trade') {
                if (selectedJavamonIdx === undefined || !selectedReceiverId) {
                    message.error("Debes seleccionar un Javamon y un destinatario.");
                    setActionLoading(false);
                    return;
                }
                const javamon = javamons[selectedJavamonIdx];
                const success = await SendTradeRequest(Number(idUsuario), selectedReceiverId, javamon.id_instance);
                if (success) {
                    message.success("Solicitud de intercambio enviada.");
                    loadData();
                    setModalVisible(false);
                } else {
                    message.error("Error al enviar solicitud.");
                }
            } else if (modalType === 'propose') {
                if (selectedJavamonIdx === undefined || !selectedTrade) {
                    message.error("Debes seleccionar un Javamon.");
                    setActionLoading(false);
                    return;
                }
                const javamon = javamons[selectedJavamonIdx];
                const success = await ProposeTrade(selectedTrade.id, javamon.id_instance);
                if (success) {
                    message.success("Propuesta enviada.");
                    loadData();
                    setModalVisible(false);
                } else {
                    message.error("Error al enviar propuesta.");
                }
            }
        } catch (e) {
            console.error(e);
        } finally {
            setActionLoading(false);
        }
    };

    // Helper para obtener candidatos a evolucionar según evolveType
    const getEligibleEvolveCandidates = () => {
        if (!evolveType) return [];

        if (evolveType === 'javamon') {
            // Javamons que posee el usuario y que tengan evoluciona_a configurado
            const jmConfigMap = new Map<number, any>();
            allJavamonsConfig.forEach(j => jmConfigMap.set(j.id, j));

            return javamons
                .map(userJm => {
                    const cfg = jmConfigMap.get(userJm.id);
                    const targetId = cfg?.evoluciona_a;
                    const targetJm = targetId ? jmConfigMap.get(targetId) : null;
                    return {
                        userItem: userJm,
                        currentNom: userJm.nom,
                        currentImage: getJavamonImage(userJm),
                        targetNom: targetJm?.nom || `Javamon #${targetId}`,
                        targetImage: targetJm ? getJavamonImage(targetJm) : '',
                        targetId: targetId,
                        isEligible: !!targetId && targetId !== userJm.id
                    };
                })
                .filter(c => c.isEligible);
        }

        // Equipamiento (arma, escut, arc)
        const unlockedIdsStr = (
            evolveType === 'arma' ? userEquipment?.unlocked_armes :
            evolveType === 'escut' ? userEquipment?.unlocked_escuts :
            evolveType === 'arc' ? userEquipment?.unlocked_arcs : null
        ) || '';

        const unlockedIds = String(unlockedIdsStr)
            .split(',')
            .map(s => Number(s.trim()))
            .filter(n => !isNaN(n) && n > 0);

        const itemsCatalog: any[] = (
            evolveType === 'arma' ? allSkins.armes :
            evolveType === 'escut' ? allSkins.escuts :
            evolveType === 'arc' ? allSkins.arcs : []
        ) || [];

        const catalogById = new Map<number, any>();
        const catalogByIdent = new Map<string, any>();
        itemsCatalog.forEach(it => {
            catalogById.set(it.id, it);
            if (it.ident) catalogByIdent.set(it.ident, it);
        });

        const unlockedIdSet = new Set(unlockedIds);

        return unlockedIds
            .map(id => {
                const current = catalogById.get(id);
                if (!current) return null;

                const evo = current.evoluciona_a;
                if (!evo || evo === 'no evoluciona') return null;

                // Buscar target por ident o por id
                const target = catalogByIdent.get(evo) || catalogById.get(Number(evo));
                if (!target) return null;

                // Si el usuario YA tiene desbloqueada la evolución destino, descartar esta opción
                // (p. ej. si tiene nivel 1, 2 y 3, no mostrar 1->2 ni 2->3, solo 3->4)
                if (unlockedIdSet.has(target.id)) return null;

                return {
                    userItem: current,
                    currentNom: current.nom,
                    currentImage: getJavamonImage({ ...current, _type: evolveType }),
                    targetNom: target.nom,
                    targetImage: getJavamonImage({ ...target, _type: evolveType }),
                    targetId: target.id,
                    isEligible: true
                };
            })
            .filter((c): c is NonNullable<typeof c> => c !== null);
    };

    const handleSelectEvolveCandidate = (candidate: any) => {
        setSelectedEvolveItem(candidate);
        setConfirmModalVisible(true);
    };

    const handleExecuteEvolve = async () => {
        if (!selectedObject || !selectedEvolveItem || !evolveType) return;
        setActionLoading(true);

        try {
            if (evolveType === 'javamon') {
                const javamonInstance = selectedEvolveItem.userItem.id_instance;
                const evolvedJavamonId = selectedEvolveItem.targetId;
                const ok = await EvolveUserJavamon(Number(idUsuario), selectedObject.id, javamonInstance, evolvedJavamonId);
                if (ok) {
                    message.success(`¡${selectedEvolveItem.currentNom} ha evolucionado a ${selectedEvolveItem.targetNom}!`);
                    setConfirmModalVisible(false);
                    setModalVisible(false);
                    loadData();
                } else {
                    message.error("Error al evolucionar el Javamon.");
                }
            } else {
                const targetId = selectedEvolveItem.targetId;
                const ok = await EvolveUserEquipment(Number(idUsuario), selectedObject.id, evolveType, targetId);
                if (ok) {
                    const tipoLabel = evolveType === 'arma' ? 'Arma' : evolveType === 'escut' ? 'Escudo' : 'Arco';
                    message.success(`¡${tipoLabel} mejorado a ${selectedEvolveItem.targetNom}! Ya está disponible en tu equipo.`);
                    setConfirmModalVisible(false);
                    setModalVisible(false);
                    loadData();
                } else {
                    message.error("Error al mejorar el equipamiento.");
                }
            }
        } catch (err) {
            console.error("Error ejecutando evolución:", err);
            message.error("Ocurrió un error inesperado al evolucionar.");
        } finally {
            setActionLoading(false);
        }
    };

    const hasRenombre = objects.find(obj => obj.tipo?.toLowerCase().includes("pergamino de nombre") || obj.tipo?.toLowerCase().includes("name scroll") || obj.tipo?.toLowerCase().includes("pergamino renombre"));
    const hasIntercambiador = objects.find(obj => obj.tipo?.toLowerCase().includes("intercambiador"));

    if (!isLoggedIn) return <Login />;

    if (loading)
        return (
            <Content style={{ padding: 40, textAlign: "center" }}>
                <Spin size="large" />
            </Content>
        );

    return (
        <Content style={{ padding: "24px", background: "#f0f2f5" }}>
            {/* ---------- POKEDEX ---------- */}
            <Card
                title="JAVAmons capturados"
                style={{
                    borderRadius: 16,
                    marginBottom: 32,
                    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                }}
            >
                {pendingTrades.length > 0 && (
                    <div style={{ marginBottom: 20 }}>
                        {pendingTrades.map((trade) => (
                            <Alert
                                key={`trade-${trade.id}`}
                                message={
                                    trade.sender_id === Number(idUsuario)
                                        ? `Intercambio enviado a ${trade.receiver_nom}: esperando propuesta...`
                                        : trade.status === 'PENDING'
                                            ? `¡${trade.sender_nom} quiere intercambiar un Javamon contigo!`
                                            : `¡${trade.receiver_nom} ha propuesto un ${trade.javamon_receiver.nom}!`
                                }
                                description={
                                    <div style={{ marginTop: 10, display: 'flex', alignItems: 'center', gap: 15 }}>
                                        {trade.sender_id === Number(idUsuario) ? (
                                            <>
                                                <span>Tu {trade.javamon_sender.nom}</span>
                                                {trade.status === 'PROPOSED' && (
                                                    <>
                                                        <span>por su {trade.javamon_receiver.nom}</span>
                                                        <Button
                                                            size="small"
                                                            type="primary"
                                                            icon={<CheckCircleOutlined />}
                                                            onClick={async () => {
                                                                await AcceptTrade(trade.id);
                                                                message.success("¡Intercambio realizado!");
                                                                loadData();
                                                            }}
                                                        >
                                                            Aceptar
                                                        </Button>
                                                    </>
                                                )}
                                                <Button
                                                    size="small"
                                                    danger
                                                    icon={<CloseCircleOutlined />}
                                                    onClick={async () => {
                                                        await RejectTrade(trade.id);
                                                        loadData();
                                                    }}
                                                >
                                                    Cancelar
                                                </Button>
                                            </>
                                        ) : (
                                            <>
                                                <span>Su {trade.javamon_sender.nom}</span>
                                                {trade.status === 'PENDING' && (
                                                    <Button
                                                        size="small"
                                                        type="primary"
                                                        onClick={() => {
                                                            setSelectedTrade(trade);
                                                            setModalType('propose');
                                                            setSelectedJavamonIdx(undefined);
                                                            setModalVisible(true);
                                                        }}
                                                    >
                                                        Proponer Javamon
                                                    </Button>
                                                )}
                                                <Button
                                                    size="small"
                                                    danger
                                                    icon={<CloseCircleOutlined />}
                                                    onClick={async () => {
                                                        await RejectTrade(trade.id);
                                                        loadData();
                                                    }}
                                                >
                                                    Rechazar
                                                </Button>
                                            </>
                                        )}
                                    </div>
                                }
                                type="info"
                                showIcon
                                style={{ marginBottom: 10, borderRadius: 10 }}
                            />
                        ))}
                    </div>
                )}
                <Row gutter={[24, 24]}>
                    {javamons.length === 0 ? (
                        <Col span={24} style={{ color: "#999" }}>
                            Aún no has capturado ningún Javamon.
                        </Col>
                    ) : (
                        javamons.map((jm, index) => (
                            <Col key={`jm-${jm.id_instance || jm.id || index}`} xs={24} sm={12} md={8} lg={6}>
                                <Badge.Ribbon
                                    text={jm.rarity?.toUpperCase() || "NORMAL"}
                                    color={jm.rarity ? (rarityMap[jm.rarity] || rarityMap[jm.rarity.toLowerCase()] || fallbackRarityStyle[jm.rarity]?.tag) : "blue"}
                                >
                                    <Card
                                        hoverable
                                        style={{
                                            borderRadius: 16,
                                            textAlign: "center",
                                            background:
                                                "linear-gradient(180deg, #ffffff 0%, #f7f7f7 100%)",
                                        }}
                                    >
                                        <img
                                            src={getJavamonImage(jm)}
                                            alt={jm.nom}
                                            style={{
                                                width: "100%",
                                                maxHeight: 160,
                                                objectFit: "contain",
                                                marginBottom: 12,
                                            }}
                                        />
                                        <h4
                                            style={{
                                                marginBottom: 4,
                                                color: jm.rarity ? (rarityMap[jm.rarity] || rarityMap[jm.rarity.toLowerCase()] || fallbackRarityStyle[jm.rarity]?.color) : "#555",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                gap: 8
                                            }}
                                        >
                                            {jm.nom}
                                            {hasRenombre && (
                                                <Tooltip title="Renombrar Javamon">
                                                    {hasRenombre.has_image || hasRenombre.image || hasRenombre.imatge ? (
                                                        <img
                                                            src={getJavamonImage(hasRenombre)}
                                                            alt="Renombrar"
                                                            style={{ width: 24, height: 24, cursor: 'pointer' }}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                setSelectedObject(hasRenombre);
                                                                setSelectedJavamonIdx(index);
                                                                setNewName('');
                                                                setModalType('rename');
                                                                setModalVisible(true);
                                                            }}
                                                        />
                                                    ) : (
                                                        <EditOutlined
                                                            style={{ cursor: 'pointer', color: '#1890ff', fontSize: 18 }}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                setSelectedObject(hasRenombre);
                                                                setSelectedJavamonIdx(index);
                                                                setNewName('');
                                                                setModalType('rename');
                                                                setModalVisible(true);
                                                            }}
                                                        />
                                                    )}
                                                </Tooltip>
                                            )}
                                            {hasIntercambiador && (
                                                <Tooltip title="Intercambiar Javamon">
                                                    {hasIntercambiador.has_image || hasIntercambiador.image || hasIntercambiador.imatge ? (
                                                        <img
                                                            src={getJavamonImage(hasIntercambiador)}
                                                            alt="Intercambiar"
                                                            style={{ width: 24, height: 24, cursor: 'pointer' }}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                setSelectedObject(hasIntercambiador);
                                                                setSelectedJavamonIdx(index);
                                                                setSelectedReceiverId(undefined);
                                                                setModalType('trade');
                                                                setModalVisible(true);
                                                            }}
                                                        />
                                                    ) : (
                                                        <RetweetOutlined
                                                            style={{ cursor: 'pointer', color: '#52c41a', fontSize: 18 }}
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                setSelectedObject(hasIntercambiador);
                                                                setSelectedJavamonIdx(index);
                                                                setSelectedReceiverId(undefined);
                                                                setModalType('trade');
                                                                setModalVisible(true);
                                                            }}
                                                        />
                                                    )}
                                                </Tooltip>
                                            )}
                                        </h4>

                                        <Tag
                                            icon={<StarFilled />}
                                            color={jm.rarity ? (rarityMap[jm.rarity] || rarityMap[jm.rarity.toLowerCase()] || fallbackRarityStyle[jm.rarity]?.color) : "blue"}
                                        >
                                            Capturado el{" "}
                                            {new Date(jm.captura).toLocaleDateString()}
                                        </Tag>
                                        <br />
                                        {jm.descr && jm.descr.includes('PROBLEMA') &&
                                            <Tooltip title="Puede revelar los fallos obtenidos en un único test de una actividad entregada">
                                                <Tag color="cyan" style={{ marginTop: 8 }}>
                                                    PROBLEMA
                                                </Tag>
                                            </Tooltip>
                                        }
                                        {jm.descr && jm.descr.includes('TIEMPO') &&
                                            <Tooltip title="Se puede gastar su carga para ampliar 24h una entrega de actividad">
                                                <Tag color="purple" style={{ marginTop: 8 }}>
                                                    TIEMPO
                                                </Tag>
                                            </Tooltip>
                                        }
                                        {jm.descr && (jm.descr.includes('NOTA')) &&
                                            <Tooltip title={`Sube 0.5 puntos la nota de la actividad (siempre que no sea ya del 100%). Cargas: ${5 - (jm.used || 0)}/5`}>
                                                <Tag color="gold" style={{ marginTop: 8, cursor: 'help' }}>
                                                    NOTA {5 - (jm.used || 0)}/5
                                                </Tag>
                                            </Tooltip>
                                        }
                                        {jm.descr && jm.descr.includes('CANDADO') &&
                                            <Tooltip title={`Puedes desbloquear un candado por Actividad accediendo así a su contenido antes que el resto.`}>
                                                <Tag color="green" style={{ marginTop: 8 }}>
                                                    CANDADO
                                                </Tag>
                                            </Tooltip>
                                        }
                                        {jm.descr && jm.descr.includes('TEST') &&
                                            <Tooltip title={`Revela TODOS los tests de un ejercicio por Actividad.`}>
                                                <Tag color="blue" style={{ marginTop: 8 }}>
                                                    TESTS
                                                </Tag>
                                            </Tooltip>
                                        }

                                        <div style={{ marginTop: 12, padding: '8px', background: '#f9f9f9', borderRadius: '8px', border: '1px solid #eee' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                                                <span style={{ fontWeight: 'bold', fontSize: '12px', color: '#666' }}>ESTADÍSTICAS</span>
                                            </div>
                                            <Row gutter={[4, 4]} style={{ fontSize: '12px' }}>
                                                <Col span={12}><span style={{ color: 'red' }}>♥</span> {jm.vida || 0}</Col>
                                                <Col span={12}><span style={{ color: 'blue' }}>🛡</span> {jm.defensa || 0}</Col>
                                                <Col span={12}><span style={{ color: 'green' }}>⚡</span> {jm.velocidad || 0}</Col>
                                                <Col span={12}><span style={{ color: 'orange' }}>⚔</span> {jm.ataque || 0}</Col>
                                            </Row>
                                        </div>

                                    </Card>
                                </Badge.Ribbon>
                            </Col>
                        ))
                    )}
                </Row>
            </Card>

            {/* ---------- MOCHILA ---------- */}
            <Card
                title="Objetos"
                style={{
                    borderRadius: 16,
                    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                }}
            >
                <Row gutter={[16, 16]}>
                    {objects.filter(obj => obj.tipo !== "Punto" && obj.color).length === 0 ? (
                        <Col span={24} style={{ color: "#999" }}>
                            No tienes objetos en la mochila.
                        </Col>
                    ) : (
                        objects
                            .filter(obj => obj.tipo !== "Punto" && obj.color)
                            .map((obj, index) => (
                                <Col key={`obj-${obj.id}-${index}`} xs={12} sm={8} md={6} lg={4}>
                                    <Tooltip title={obj.descripcio}>
                                        <Card
                                            hoverable
                                            onClick={() => handleItemClick(obj)}
                                            style={{
                                                borderRadius: 16,
                                                textAlign: "center",
                                                background: "#ffffff",
                                                boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
                                                cursor: obj.punts > 0 ? "default" : "pointer"
                                            }}
                                        >
                                            {obj.has_image || obj.image || obj.imatge ? (
                                                <img
                                                    src={getJavamonImage(obj)}
                                                    alt={obj.tipo}
                                                    style={{
                                                        width: '100%',
                                                        height: 100,
                                                        objectFit: 'contain',
                                                        marginBottom: 12
                                                    }}
                                                />
                                            ) : (
                                                <>
                                                    {/* Pokéball */}
                                                    <TbPokeball
                                                        size={64}
                                                        style={{
                                                            color: obj.color,
                                                            marginBottom: 12,
                                                        }}
                                                    />

                                                    {/* Puntos */}
                                                    <div
                                                        style={{
                                                            fontSize: 20,
                                                            fontWeight: 700,
                                                            color: obj.color,
                                                        }}
                                                    >
                                                        {obj.punts > 0 ? `${obj.punts}%` : ''}
                                                    </div>
                                                </>
                                            )}

                                            {/* Tipo */}
                                            <div
                                                style={{
                                                    fontSize: 12,
                                                    textTransform: "uppercase",
                                                    color: "#666",
                                                }}
                                            >
                                                {obj.tipo}
                                            </div>
                                        </Card>
                                    </Tooltip>
                                </Col>
                            ))

                    )}
                </Row>
            </Card>

            <Modal
                title={
                    modalType === 'rename' ? "Usar Pergamino de Nombre" :
                        modalType === 'incense' ? "Usar Incienso" :
                            modalType === 'ability' ? "Usar Habilidad" :
                                modalType === 'trade' ? "Iniciar Intercambio" :
                                    modalType === 'propose' ? "Proponer Intercambio" :
                                    modalType === 'generate_avatar' ? "Generar Avatar" :
                                        modalType === 'evolve' ? (
                                                evolveType === 'arma' ? "Mejora de Arma" :
                                                evolveType === 'escut' ? "Mejora de Escudo" :
                                                evolveType === 'arc' ? "Mejora de Arco" : "Mejora de JAVAmon"
                                            ) : ""
                }
                open={modalVisible}
                onCancel={() => setModalVisible(false)}
                width={modalType === 'evolve' ? 780 : 520}
                footer={modalType === 'evolve' ? [
                    <Button key="back" onClick={() => setModalVisible(false)}>Cerrar</Button>
                ] : [
                    <Button key="back" onClick={() => setModalVisible(false)}>Cancelar</Button>,
                    <Button key="submit" type="primary" loading={actionLoading} onClick={confirmAction}>Confirmar</Button>
                ]}
            >
                {modalType === 'evolve' && (
                    <div>
                        <p style={{ color: '#666', marginBottom: 16 }}>
                            {evolveType === 'javamon'
                                ? "Selecciona el Javamon que deseas evolucionar a su siguiente fase:"
                                : `Selecciona el ${evolveType === 'arma' ? 'arma' : evolveType === 'escut' ? 'escudo' : 'arco'} que deseas mejorar a su siguiente nivel:`}
                        </p>

                        {(() => {
                            const candidates = getEligibleEvolveCandidates();
                            if (candidates.length === 0) {
                                return (
                                    <div style={{ textAlign: 'center', padding: '30px 10px', color: '#999' }}>
                                        <ExclamationCircleOutlined style={{ fontSize: 36, color: '#faad14', marginBottom: 12 }} />
                                        <p style={{ fontSize: 15, fontWeight: 500 }}>No tienes ningún elemento compatible que pueda evolucionar.</p>
                                        <p style={{ fontSize: 13 }}>
                                            {evolveType === 'javamon'
                                                ? "Ninguno de tus Javamons actuales tiene una evolución configurada."
                                                : `Ninguno de tus ${evolveType === 'arma' ? 'armas' : evolveType === 'escut' ? 'escudos' : 'arcos'} desbloqueados dispone de una mejora siguiente.`}
                                        </p>
                                    </div>
                                );
                            }

                            return (
                                <Row gutter={[16, 16]} style={{ maxHeight: 420, overflowY: 'auto', paddingRight: 4 }}>
                                    {candidates.map((cand, idx) => (
                                        <Col key={`evolve-cand-${idx}`} xs={24} sm={12}>
                                            <Card
                                                hoverable
                                                onClick={() => handleSelectEvolveCandidate(cand)}
                                                style={{
                                                    borderRadius: 14,
                                                    border: '1.5px solid #e8e8e8',
                                                    transition: 'all 0.25s ease',
                                                    boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                                                    cursor: 'pointer'
                                                }}
                                                bodyStyle={{ padding: 14 }}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
                                                    {/* Origen */}
                                                    <div style={{ textAlign: 'center', flex: 1, minWidth: 0 }}>
                                                        <div style={{
                                                            width: 70,
                                                            height: 70,
                                                            margin: '0 auto 6px auto',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            background: '#f7f7f7',
                                                            borderRadius: 10
                                                        }}>
                                                            {cand.currentImage ? (
                                                                <img
                                                                    src={cand.currentImage}
                                                                    alt={cand.currentNom}
                                                                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                                                />
                                                            ) : (
                                                                <span style={{ fontSize: 24 }}>⚔️</span>
                                                            )}
                                                        </div>
                                                        <div style={{
                                                            fontWeight: 600,
                                                            fontSize: 13,
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            color: '#333'
                                                        }} title={cand.currentNom}>
                                                            {cand.currentNom}
                                                        </div>
                                                    </div>

                                                    {/* Flecha hacia evolución */}
                                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: '#1890ff', padding: '0 4px' }}>
                                                        <ArrowRightOutlined style={{ fontSize: 18 }} />
                                                        <span style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5, marginTop: 2 }}>
                                                            Mejora
                                                        </span>
                                                    </div>

                                                    {/* Destino */}
                                                    <div style={{ textAlign: 'center', flex: 1, minWidth: 0 }}>
                                                        <div style={{
                                                            width: 70,
                                                            height: 70,
                                                            margin: '0 auto 6px auto',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            background: '#f0f5ff',
                                                            border: '1px dashed #91d5ff',
                                                            borderRadius: 10
                                                        }}>
                                                            {cand.targetImage ? (
                                                                <img
                                                                    src={cand.targetImage}
                                                                    alt={cand.targetNom}
                                                                    style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                                                />
                                                            ) : (
                                                                <span style={{ fontSize: 24 }}>✨</span>
                                                            )}
                                                        </div>
                                                        <div style={{
                                                            fontWeight: 600,
                                                            fontSize: 13,
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            color: '#096dd9'
                                                        }} title={cand.targetNom}>
                                                            {cand.targetNom}
                                                        </div>
                                                    </div>
                                                </div>

                                                <Button
                                                    type="primary"
                                                    block
                                                    size="small"
                                                    style={{ marginTop: 12, borderRadius: 6 }}
                                                >
                                                    Evolucionar
                                                </Button>
                                            </Card>
                                        </Col>
                                    ))}
                                </Row>
                            );
                        })()}
                    </div>
                )}
                {modalType === 'rename' && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <p>Selecciona el Javamon al que quieres cambiar el nombre:</p>
                        <Select
                            style={{ width: '100%' }}
                            placeholder="Selecciona Javamon"
                            value={selectedJavamonIdx !== undefined ? selectedJavamonIdx : undefined}
                            onChange={(val) => setSelectedJavamonIdx(val)}
                        >
                            {javamons.map((j, idx) => (
                                <Select.Option key={`j_o_${idx}`} value={idx}>{j.nom} - {new Date(j.captura).toLocaleDateString()}</Select.Option>
                            ))}
                        </Select>
                        <Input
                            placeholder="Nuevo nombre"
                            value={newName}
                            onChange={e => setNewName(e.target.value)}
                        />
                    </div>
                )}
                {modalType === 'incense' && (
                    <p>¿Quieres usar el Incienso? Aumentará la probabilidad de aparición de Javamons en un 10% durante 30 minutos.</p>
                )}
                {modalType === 'generate_avatar' && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <p>¿Quieres usar <b>Generar Avatar</b>?</p>
                        <p style={{ fontSize: 13, color: '#666' }}>
                            Se desbloquearán de forma aleatoria una <b>skin</b> y un <b>avatar</b> de entre
                            las recompensas de actividades ya finalizadas que todavía no tengas. Se consumirá
                            el objeto solo si se obtiene al menos una recompensa.
                        </p>
                    </div>
                )}
                {modalType === 'ability' && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <p>Selecciona el Javamon al que quieres aplicar la habilidad:</p>
                        <Select
                            style={{ width: '100%' }}
                            placeholder="Selecciona Javamon"
                            value={selectedJavamonIdx !== undefined ? selectedJavamonIdx : undefined}
                            onChange={(val) => setSelectedJavamonIdx(val)}
                        >
                            {javamons.map((j, idx) => (
                                <Select.Option key={`j_a_${idx}`} value={idx}>{j.nom} - {new Date(j.captura).toLocaleDateString()}</Select.Option>
                            ))}
                        </Select>
                        <p style={{ marginTop: '10px', fontSize: '13px', color: '#666' }}>
                            Nota: La habilidad asignada será aleatoria y dependerá de la rareza del pergamino (Épico o Legendario).
                        </p>
                    </div>
                )}
                {modalType === 'trade' && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <p>Selecciona el usuario con el que quieres intercambiar:</p>
                        <Select
                            showSearch
                            style={{ width: '100%' }}
                            placeholder="Buscar usuario"
                            optionFilterProp="children"
                            value={selectedReceiverId}
                            onChange={(val) => setSelectedReceiverId(val)}
                        >
                            {users.map(u => (
                                <Select.Option key={`u_${u.id}`} value={u.id}>{u.nom}</Select.Option>
                            ))}
                        </Select>
                        <p style={{ fontSize: '12px', color: '#888' }}>
                            Se consumirá un Intercambiador si se completa el intercambio.
                        </p>
                    </div>
                )}
                {modalType === 'propose' && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        <p>Selecciona el Javamon que quieres ofrecer a cambio:</p>
                        <Select
                            style={{ width: '100%' }}
                            placeholder="Selecciona Javamon"
                            value={selectedJavamonIdx !== undefined ? selectedJavamonIdx : undefined}
                            onChange={(val) => setSelectedJavamonIdx(val)}
                        >
                            {javamons.map((j, idx) => (
                                <Select.Option key={`j_p_${idx}`} value={idx}>{j.nom}</Select.Option>
                            ))}
                        </Select>
                    </div>
                )}
            </Modal>

            {/* Modal de conformidad para usar el consumible de evolución */}
            <Modal
                title="Confirmar evolución"
                open={confirmModalVisible}
                onCancel={() => !actionLoading && setConfirmModalVisible(false)}
                footer={[
                    <Button key="cancel" disabled={actionLoading} onClick={() => setConfirmModalVisible(false)}>
                        Cancelar
                    </Button>,
                    <Button key="confirm" type="primary" loading={actionLoading} onClick={handleExecuteEvolve}>
                        Sí, usar y evolucionar
                    </Button>
                ]}
            >
                {selectedEvolveItem && (
                    <div style={{ textAlign: 'center', padding: '10px 0' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 20, marginBottom: 16 }}>
                            <div style={{ textAlign: 'center' }}>
                                <div style={{ width: 80, height: 80, background: '#f5f5f5', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 8px auto' }}>
                                    {selectedEvolveItem.currentImage ? (
                                        <img src={selectedEvolveItem.currentImage} alt={selectedEvolveItem.currentNom} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                                    ) : (
                                        <span style={{ fontSize: 28 }}>⚔️</span>
                                    )}
                                </div>
                                <b style={{ fontSize: 13 }}>{selectedEvolveItem.currentNom}</b>
                            </div>

                            <ArrowRightOutlined style={{ fontSize: 24, color: '#1890ff' }} />

                            <div style={{ textAlign: 'center' }}>
                                <div style={{ width: 80, height: 80, background: '#e6f7ff', borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 8px auto', border: '1px solid #91d5ff' }}>
                                    {selectedEvolveItem.targetImage ? (
                                        <img src={selectedEvolveItem.targetImage} alt={selectedEvolveItem.targetNom} style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                                    ) : (
                                        <span style={{ fontSize: 28 }}>✨</span>
                                    )}
                                </div>
                                <b style={{ fontSize: 13, color: '#096dd9' }}>{selectedEvolveItem.targetNom}</b>
                            </div>
                        </div>

                        <p style={{ fontSize: 14 }}>
                            ¿Estás seguro de que quieres usar <b>{selectedObject?.tipo}</b> para evolucionar <b>{selectedEvolveItem.currentNom}</b> a <b>{selectedEvolveItem.targetNom}</b>?
                        </p>

                        <p style={{ fontSize: 12, color: '#888' }}>
                            {evolveType === 'javamon'
                                ? "Se consumirá el objeto de mejora de tu inventario. Tu Javamon actual se transformará en el nuevo manteniendo su apodo si lo tenía."
                                : `Se consumirá el objeto de mejora de tu inventario. Desbloquearás el nuevo ${evolveType === 'arma' ? 'arma' : evolveType === 'escut' ? 'escudo' : 'arco'} y conservarás el anterior.`}
                        </p>
                    </div>
                )}
            </Modal>

            {/* Modal de resultado de "Generar Avatar" */}
            <Modal
                title="¡Recompensa generada!"
                open={resultModalVisible}
                onCancel={() => setResultModalVisible(false)}
                footer={[
                    <Button key="ok" type="primary" onClick={() => setResultModalVisible(false)}>
                        ¡Genial!
                    </Button>
                ]}
            >
                {generatedResult && (
                    <div style={{ textAlign: 'center', padding: '10px 0' }}>
                        <p style={{ marginBottom: 20, color: '#666' }}>
                            Has obtenido las siguientes recompensas aleatorias:
                        </p>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: 32, flexWrap: 'wrap' }}>
                            {generatedResult.skinId !== null && (
                                <div style={{ textAlign: 'center' }}>
                                    <div style={{
                                        width: 110, height: 110, margin: '0 auto 8px auto',
                                        background: '#f0f5ff', border: '1px solid #91d5ff', borderRadius: 14,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                                    }}>
                                        <img
                                            src={`${apiUrl}:8061/jutge/game/image/skin/${generatedResult.skinId}`}
                                            alt={generatedResult.skinNom || 'Skin'}
                                            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                        />
                                    </div>
                                    <Tag color="purple" style={{ marginBottom: 4 }}>SKIN</Tag>
                                    <div style={{ fontWeight: 600 }}>{generatedResult.skinNom || `Skin #${generatedResult.skinId}`}</div>
                                </div>
                            )}
                            {generatedResult.avatarId !== null && (
                                <div style={{ textAlign: 'center' }}>
                                    <div style={{
                                        width: 110, height: 110, margin: '0 auto 8px auto',
                                        background: '#f6ffed', border: '1px solid #b7eb8f', borderRadius: 14,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                                    }}>
                                        <img
                                            src={`${apiUrl}:8061/jutge/game/image/avatar/${generatedResult.avatarId}`}
                                            alt={generatedResult.avatarNom || 'Avatar'}
                                            style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                        />
                                    </div>
                                    <Tag color="green" style={{ marginBottom: 4 }}>AVATAR</Tag>
                                    <div style={{ fontWeight: 600 }}>{generatedResult.avatarNom || `Avatar #${generatedResult.avatarId}`}</div>
                                </div>
                            )}
                        </div>
                        <p style={{ marginTop: 20, fontSize: 12, color: '#999' }}>
                            Ya están disponibles en tu perfil para equipar.
                        </p>
                    </div>
                )}
            </Modal>
        </Content >
    );
};

export default Mochila;
